module.exports = {
	"next": "nächstes",
	"skip": "Jump to the Cozy creation",
	"cancel": "abbrechen",
	"back": "zurück",
	"sign up": "registrieren",
	"add email": "E-Mail Account hinzufügen",
	"welcome": "Lass mich rein!",
	"confirm": "bestätigen",
	"user missing properties": "Sorry, aber dieser Benutzer existiert nicht.",
	"step welcome user": "Willkommen %{name}!",
	"step welcome anon": "Willkommen!",
	"step welcome logout": "Sind Sie nicht %{name}?",
	"step welcome congrats": "Gratulation, dank dir sind deine persönlichen Daten in einem sicheren Ort, deiner Cozy.",
	"step welcome next": "Nächstes",
	"step agreement title": "Nutzungsbedingungen",
	"step agreement subtitle": "Um dich bei Cozy zu einzuloggen musst du die Nutzungsbedingungen akzeptieren. Normalerweise tut das niemand darum bieten wir dir eine verkürze und besser verständliche Version:",
	"step agreement element 0": "übernimm die Kontrolle und Verantwortung über deine persönlichen Daten, bei dir zuhause.",
	"step agreement element 1": "Wir achten auf dich und dein cozy...",
	"step agreement element 2": "...ausser du tust was falsches mit Cozy oder deinen Daten",
	"step agreement element 3": "Entscheide welche dienste auf deine daten zugreifen und verstehe ihre Ziele",
	"step agreement element 4": "Niemand (auch wir nicht) können auf deine Daten in Cozy zugreifen",
	"step agreement element 5": "Wir speichern so einzelne details von dir einerseits um Rechtliche aspekte abzudecken andererseits um die Service Qualität zu erhöhen",
	"step agreement stats": "Ich lasse Cozy anonyme Daten sammeln",
	"step agreement description 1": "Ich greife auf die Nutzungsbedingungen zu",
	"step agreement description 2": "Beim Klicken auf \"Akzeptieren\" bestätigst du dass du die Nutzungsbestimmungen gelesen und verstanden hast. Und du bist dir über die Verpflichtungen der Bedingungen bewusst.",
	"step agreement description link": "hier.",
	"step agreement next": "Akzeptieren",
	"step preset": "Einstellungen",
	"step import": "Importieren Sie Ihre Daten",
	"step email settings": "configure your email",
	"preset email": "E-Mail",
	"preset email tip": "Diese wird benutzt, um Sie zu kontaktieren, falls Sie Ihr Passwort verlieren.",
	"preset name": "Name",
	"step password empty": "Der Inhalt des Passwortfeldes fehlt.",
	"step password too weak": "Dein Passwort ist zu schwach. Du solltest im Minimum einen Grossbuchstaben, eine Nummer und einen spezial charakter eingeben oder das Passwort länger machen.",
	"step password title": "Sichern Sie Ihr Passwort",
	"step password label": "Passwort",
	"step password input placeholder": "z.B. \"dEj875ghj9273;eR\"",
	"step password submit": "bestätigen",
	"step password show": "Passwort anzeigen",
	"step password hide": "Passwort verstecken",
	"step password description": "Ihr Passwort muss so kompliziert wie möglich sein. Dies wird verhindern, dass bösartige Personen Zugriff auf Ihre eigene Cloud erhalten. Deshalb sind in Ihrem Passwort ein Großbuchstabe, eine Ziffer und ein Sonderzeichen notwendig.",
	"step password server error": "Es ist etwas schief gegangen. Ihr Passwort wurde nicht gespeichert.",
	"step infos title": "Fertigstellung von Cozy",
	"step infos description": "Einige Informationen sind nötig um Cozy aufzusetzen.",
	"step infos public_name label": "Benutzername",
	"step infos public_name placeholder": "Der öffentliche name mit dem Cozy dich ansprechen wird.",
	"step infos email label": "Email",
	"step infos email placeholder": "Verwendet von deinem Cozy um das Passwort zurückzusetzen.",
	"step infos timezone label": "Zeitzone",
	"step infos timezone placeholder": "Deine Zeitzone hilft dir die Kalenderanzeige korrekt zu Anzuzeigen.",
	"step infos submit": "Akzeptieren",
	"step infos fetch data error": "Keine Verbindung zum Server.",
	"missing public_name": "Du musst deinen Benutzernamen eingeben.",
	"missing email": "Du musst deine Email angeben.",
	"invalid email format": "Deine Email-Adresse scheint nicht richtig zu sein.",
	"missing timezone": "Du musst deine Zeitzone angeben.",
	"invalid timezone": "Deine Zeitzone scheint nicht Korrekt zu sein.",
	"step accounts title": "Ihre Cozy wurde erfolgreich erstellt!",
	"step accounts description line 1": "Jetzt werden wie Sie beim Verbinden Ihrer Cozy-Cloud mit Ihren Services unterstützen.",
	"step accounts description line 2": "Schlussendlich ist es Cozy's Ziel, Ihnen dabei zu helfen, Ihre Daten zurückzugewinnen.",
	"step accounts next": "Durchsuchen",
	"myaccounts info": "Du kannst nun dein Cozy jederzeit mit klick auf \"weiter\" betreten",
	"myaccounts next": "weiter",
	"step confirmation title": "Willkommen auf deiner Persönlichen Datenwolke!",
	"step confirmation description line 1": "Dein Cozy ist nun bereit.",
	"step confirmation description line 2": "Du kannst deine Daten von vielen anwendungen wiederherstellen und die Anwendungen die du willst vom Laden installieren. ",
	"step confirmation next": "bestätigen",
	"step server error": "Ein fehler während dem speichern ist aufgetreten. Lade die Seite neu, das sollte genügen um das Problem zu beheben.",
	"preset name tip": "It's displayed when you share files with people or invite them to events.",
	"preset password": "Passwort",
	"preset password tip": "Ein sicheres Passwort mit mindestens 8 Zeichen ist pflicht. Spezialcharakter härten die Sicherheit zusätzlich ab.",
	"preset timezone": "Zeitzone",
	"preset timezone tip": "Deine Zeitzone wird gebraucht um die Kalenderdaten richtig anzuzeigen.",
	"preset opt-in help": "Gewähre Cozy die Nutzungsberichte zu sammeln um das Produkt noch besser zu machen.",
	"preset opt-out newsletter": "Abboniere den Cozy Beta Newsletter (empfohlen).",
	"import from google": "Importiere meine Daten aus meinem Google Konto",
	"import google account": "Synchronisiere dein Gmail Konto und importiere Kalender, Kontakte und Fotos",
	"import google account tip": "Du wirst dich bei Google Einloggen müssen um deinem Cozy zugang zu den auf Google lagernden Daten zu gewähren.",
	"leave google title": "Füttere dein Cozy mit deinen Daten",
	"leave google help me": "Ich verstehe nicht was ich tun soll, bitte helft mir!",
	"leave google sign in content": "Loge dich bei Google ein und gib deinem Cozy die Berechtigung zum Zugang. Du wirst einen Komplizierten Code erhalten. Kopiere Ihn in die Zwischenablage.",
	"leave google sign in": "Loge dich bei Google ein.",
	"leave google code content": "Danach Kopiere und füge den code vom Popup-Fenster in dieses Feld ein:",
	"leave google code": "google code",
	"leave google url doc": "https://docs.cozy.io/de/mobile/import-google.html",
	"leave google choice": "Entscheide was du mit den Daten auf Google Servern tun möchtest:",
	"leave google choice sync gmail": "GMail - Verwende dein email aus Cozy",
	"leave google choice contacts": "Einmaliges Importieren von Google Kontakte",
	"leave google choice calendar": "Einmaliges Importieren von Google Kalender",
	"leave google choice photos": "Einmaliges Importieren von Google Fotos",
	"leave google confirm": "Daten Importieren",
	"import error": "Ein fehler ist beim versuch deine Daten zu Importieren aufgetreten. Bitte versuche es später über die App nochmals.",
	"login welcome user": "Willkommen %{username}",
	"login welcome anon": "Willkommen",
	"login enter your password": "gib dein Passwort ein um dein Cozy zu betreten",
	"login password": "password",
	"login otp": "Authentifizierungscode",
	"login submit": "Authentifizieren",
	"login auth success": "Authentifizierung erfolgreich, lass uns eintreten!",
	"login recover": "Hast du dein Passwort vergessen? Sende mir eine Email um es zu ändern.",
	"login recover busy": "Ein Email mit Anweisungen wird versendet",
	"login recover sent title": "Email versandt",
	"login recover sent message": "Bitte kontrolliere dein Postfach und folge den Anweisungen um dein Passwort zurückzusetzen",
	"login recover error title": "Fehler beim versenden der Email",
	"login recover error message": "Fehler beim versenden des Passwort zurücksetzen Emails, bitte prüffe ob dein MTA läuft oder kontaktiere den Serveradministrator",
	"login wrong password title": "Falsche Zugangsdaten",
	"login wrong password message": "Deine Zugangsdaten sind nicht korrekt. Bitte versuche es noch mals.",
	"login server error": "Ein Fehler ist aufgetreten, bitte versuche es nochmals.",
	"reset password request success title": "Email ist versandt worden",
	"reset password request success message": "Bitte kontrolliere dein Postfach und folge den Anweisungen um dein Passwort zurückzusetzen",
	"reset password request error": "Ein Fehler ist aufgetreten, das Email konnte nicht versandt werden. Versuche es nochmals und kontaktiere nachgängig gegebenenfalls contact@cozycloud.cc falls das Problem weiterhin besteht.",
	"reset welcome user": "Wechsle dein Passwort",
	"reset enter your password": "%{username}, setze ein neues Passwort um den zugang zu deinem Cozy wieder herzustellen.",
	"reset password": "Passwort",
	"reset submit": "Passwort zurücksetzen",
	"reset auth success": "Passwort erfolgreich zurückgesetzt",
	"reset wrong password title": "Ihr Passwort kann nicht zurückgesetzt werden",
	"reset wrong password message": "Das von Ihnen eingegebene Passwort ist falsch oder Ihr Schlüssel zum Zurücksetzen des Passworts ist abgelaufen",
	"reset password error invalid key": "Deine Passwort anfrage ist abgelaufen. Bitte löse eine neue aus.",
	"reset password error password too weak": "Dein Passwort ist zu schwach. Du solltest im mindestens einen Grossbuchstaben, eine Nummer und ein Spezialzeichen integrieren.",
	"setup title": "Wir richten gerade Ihre Cozy-Cloud ein...",
	"setup message": "Sie sind jetzt nahe dran, Ihre eigene persönliche Cloud zu haben, in welcher Ihre Daten gespeichert sind.",
	"setup on mobile title": "Synchronisieren Sie Ihre Daten mit Ihrem Android-Gerät!",
	"setup on mobile message": "Testen Sie unsere Android-App im Google Play Store:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/de.json
// module id = 37
// module chunks = 0